import React, { Component } from "react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import Table from "../../components/common/table";
import Like from "../../components/common/like";
// import Confirm from "../../components/common/confirm";
import Delete from "../../components/common/delete";
import BonusStatus from "../../components/common/bonusStatus";
import moment from "moment";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class BonusesTable extends Component {
  columns = [
    { 
      path: "status", 
      content: bonus => <BonusStatus status={bonus.status} />
    },
    {
      path: "account",
      label: "Account",
      content: bonus => <Link to={`/accounts/${bonus.account}`}>{bonus.account
        ? bonus.account
        : "Unknown"}</Link>
    },
    {
      path: "bonusid",
      label: "Bonus ID",
      // content: bonus => <Link to={`/bonuses/${bonus.id}`}>{bonus.bonusid}</Link>
      content: bonus => bonus.bonusid
    },
    {
      path: "bonus",
      label: "Bonus",
      content: bonus => bonus.quantity && bonus.unit 
      ? `${bonus.quantity} ${bonus.quantity === 1 ? capitalizeFirstLetter(bonus.unit.slice(0, -1)) : capitalizeFirstLetter(bonus.unit)}`
      : "N/A"
    },
    {
      path: "reason",
      label: "Reason",
    },
    { 
      path: "createdAt", 
      label: "Date",
      content: bonus => (
        <span title={moment(bonus.createdAt).format('dddd, MMMM Do, YYYY')}>
          {moment(bonus.createdAt).format('Do MMM.  YYYY')}
        </span>
      )
    },
  ];

  likeColumn = {
    key: "like",
    content: bonus => (
      <Like liked={bonus.liked} onClick={() => this.props.onLike(bonus)} />
    )
  }  

  deleteColumn = {
    key: "delete",
    content: bonus => (
      <Delete onClick={() => this.props.onDelete(bonus)} />
    )
  };

  // confirmcolumn = {
  //   key: "confirm",
  //   content: bonus => (
  //     <Confirm confirmed={bonus.confirmed} onClick={() => this.props.onConfirm(bonus)} />    
  //   )
  // };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    // if (user && user.role && (user.role === "Manager" || user.role === "Administrator")) this.columns.push(this.likeColumn);
    // if (user && user.role && user.role === "Administrator") this.columns.push(this.deleteColumn);
    // if (user && user.role && (user.role === "Manager" || user.role === "Administrator")) this.columns.push(this.confirmcolumn);
  }

  render() {
    const { bonuses, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={bonuses}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default BonusesTable;
